module.exports = __webpack_public_path__ + "img/20190813155734146.ddf90d82.png";